export const USER_GROUP_TYPES = {
  team: 'team',
  vc_group: 'vc_group',
  cohort: 'cohort'
};
